import Nav from "@/components/Nav";
import Playbook from "@/components/Playbook";
import Footer from "@/components/Footer";

export default function PlaybookPage() {
  return (
    <>
      <Nav />
      <main>
        <Playbook />
      </main>
      <Footer />
    </>
  );
}
